/* eslint-disable max-len */
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  MenuProps,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  TextField,
  Typography
} from '@mui/material';
import { useMemo, useState } from 'react';
import useComunidadesRuraisTradicionaisStore, { IComunidadesRuraisTradicionais } from 'stores/forms/comunidades_rurais_tradicionais';
import { FormikProps } from 'formik';
import { FormularioComunidadesFormik } from 'interfaces/formularioComunidades.interface';
import { ContainerFormFormik } from 'components/shared/container_form_formik';
import ButtonForm from 'components/buttons/button-form';

interface Escola {
  jurisdicao: string;
  nome: string;
}

interface Step2Props {
  onNext: () => void;
  formik: FormikProps<FormularioComunidadesFormik>;
  open: boolean;
  setOpen: (open: boolean) => void;
  onBack?: () => void;
  stepAtual: number;
  totalSteps: number;
}

export const yesNoToBool = (v: string) => {
  if (v === 'Sim') return true;
  if (v === 'Não') return false;
  return null;
};

export const buildStep2Payload = (
  comunidades: IComunidadesRuraisTradicionais,
): Partial<IComunidadesRuraisTradicionais> => {
  const payload: Partial<IComunidadesRuraisTradicionais> = {
    step_atual: 3,

    possui_energia_eletrica: comunidades.possui_energia_eletrica ?? null,
    possui_saneamento_basico: comunidades.possui_saneamento_basico ?? null,
    coleta_de_lixo: comunidades.coleta_de_lixo ?? null,
    recebeu_manutencao_das_estradas_no_ultimo_ano:
      comunidades.recebeu_manutencao_das_estradas_no_ultimo_ano ?? null,
    possui_escolas: comunidades.possui_escolas ?? null,
    possui_esgotamento_sanitario: comunidades.possui_esgotamento_sanitario ?? null,
    possui_cultura_manejo_solo: comunidades.possui_cultura_manejo_solo ?? null,
    tem_degradacao_solo: comunidades.tem_degradacao_solo ?? null,
    tem_assoreamento_fluvial: comunidades.tem_assoreamento_fluvial ?? null,

    // escolas
    escola_json: [[]],

    // bloco 2
    possui_oferta_de_transporte_escolar_para_os_estudantes:
      comunidades.possui_oferta_de_transporte_escolar_para_os_estudantes ?? null,
    possui_unidade_de_saude: comunidades.possui_unidade_de_saude ?? null,
    recebeu_agentes_de_saude_do_municipio:
      comunidades.recebeu_agentes_de_saude_do_municipio ?? null,
    tem_acesso_internet: comunidades.tem_acesso_internet ?? null,
  };

  return payload;
};

export const hasRequiredErrorsPure = (
  comunidades: IComunidadesRuraisTradicionais,
) => {
  const reqBools: (keyof IComunidadesRuraisTradicionais)[] = [
    'possui_energia_eletrica',
    'possui_saneamento_basico',
    'coleta_de_lixo',
    'recebeu_manutencao_das_estradas_no_ultimo_ano',
    'possui_escolas',
    'possui_esgotamento_sanitario',
    'possui_cultura_manejo_solo',
    'tem_degradacao_solo',
    'tem_assoreamento_fluvial',
    'possui_oferta_de_transporte_escolar_para_os_estudantes',
    'possui_unidade_de_saude',
    'recebeu_agentes_de_saude_do_municipio',
    'tem_acesso_internet',
  ];

  for (const k of reqBools) {
    const v = comunidades[k];
    if (v === null || v === undefined) {
      return true;
    }
  }

  return false;
};

// Handler factories extracted for easier unit testing
export const createYesNoRadioHandler = (
  setPartialForm: (key: keyof IComunidadesRuraisTradicionais, value: any) => void,
) => <K extends keyof IComunidadesRuraisTradicionais>(key: K, v: string) => {
  const value = yesNoToBool(v);
  setPartialForm(key, value);
};

export const Step2: React.FC<Step2Props> = ({
  onNext,
  onBack,
  stepAtual,
  totalSteps
}) => {
  const {
    comunidadesRuraisTradicionais,
    setComunidadesRuraisTradicionais,
    setPartialForm,
    saveStep2,
  } = useComunidadesRuraisTradicionaisStore();

  const yearSubtitle = useMemo(() => {
    return '';
  }, [comunidadesRuraisTradicionais.ano_referencia_do_questionario]);

  const SelectMenuProps: Partial<MenuProps> = {
    PaperProps: {
      sx: {
        width: '90%',
        maxHeight: '300px',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
        '& .MuiMenuItem-root': { padding: '12px 16px' },
      },
    },
    anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
    transformOrigin: { vertical: 'top', horizontal: 'right' },
  };

  // Bind handler factories to current state/setters
  const yesNoHandler = createYesNoRadioHandler(setPartialForm);

  const buildStep2Fields = (): Partial<IComunidadesRuraisTradicionais> => {
    const payload = buildStep2Payload(comunidadesRuraisTradicionais);
    console.log('[STEP2] buildStep2Fields -> payload pronto:', payload);
    return payload;
  };

  const hasRequiredErrors = () => {
    const res = hasRequiredErrorsPure(comunidadesRuraisTradicionais);
    if (res) console.warn('[STEP2] Validação: há erros obrigatórios');
    return res;
  };

  const handleAdvanced = async () => {
    console.log('[STEP2] Avançar: estado atual (antes de build/save):', {
      possui_energia_eletrica: comunidadesRuraisTradicionais.possui_energia_eletrica,
      possui_saneamento_basico: comunidadesRuraisTradicionais.possui_saneamento_basico,
      coleta_de_lixo: comunidadesRuraisTradicionais.coleta_de_lixo,
      recebeu_manutencao_das_estradas_no_ultimo_ano: comunidadesRuraisTradicionais.recebeu_manutencao_das_estradas_no_ultimo_ano,
      possui_escolas: comunidadesRuraisTradicionais.possui_escolas,
      possui_esgotamento_sanitario: comunidadesRuraisTradicionais.possui_esgotamento_sanitario,
      possui_cultura_manejo_solo: comunidadesRuraisTradicionais.possui_cultura_manejo_solo,
      tem_degradacao_solo: comunidadesRuraisTradicionais.tem_degradacao_solo,
      tem_assoreamento_fluvial: comunidadesRuraisTradicionais.tem_assoreamento_fluvial,
      escola_json: comunidadesRuraisTradicionais.escola_json,
      possui_oferta_de_transporte_escolar_para_os_estudantes: comunidadesRuraisTradicionais.possui_oferta_de_transporte_escolar_para_os_estudantes,
      possui_unidade_de_saude: comunidadesRuraisTradicionais.possui_unidade_de_saude,
      recebeu_agentes_de_saude_do_municipio: comunidadesRuraisTradicionais.recebeu_agentes_de_saude_do_municipio,
      tem_acesso_internet: comunidadesRuraisTradicionais.tem_acesso_internet,
    });

    if (hasRequiredErrors()) {
      console.warn('[STEP2] Bloqueado por validação. Não vai chamar saveStep2.');
      return;
    }

    const current = comunidadesRuraisTradicionais || ({} as IComunidadesRuraisTradicionais);
    const partial = buildStep2Fields();

    console.log('[STEP2] setComunidadesRuraisTradicionais (merge parcial) ->', partial);
    setComunidadesRuraisTradicionais({
      ...current,
      ...partial,
    });

    console.log('[STEP2] Chamando saveStep2()...');
    const ok = await saveStep2();
    console.log('[STEP2] saveStep2() retorno:', ok);
    if (!ok) {
      console.error('[STEP2] saveStep2 falhou.');
      return;
    }

    onNext();
  };




  return (
    <>
      <Typography
        variant='h5'
        sx={{ mt: 4, mb: 3, fontSize: '24px', fontWeight: 400, textAlign: 'center' }}
      >
        Infraestrutura e Serviços
      </Typography>

      <Box>
        <ContainerFormFormik
          title='Infraestrutura e Serviços'
          subtitle={yearSubtitle}
          onSubmit={onNext}
        >
          {/* Bloco 1 - Perguntas iniciais (2 colunas) */}
          <Grid container spacing={3} sx={{ mb: 3 }}>
            {[
              { label: 'Possui energia elétrica?', key: 'possui_energia_eletrica' as const },
              { label: 'Possui abastecimento de água potável? *', key: 'possui_saneamento_basico' as const },
              { label: 'Possui coleta seletiva de resíduos? *', key: 'coleta_de_lixo' as const },
              { label: 'Recebeu manutenção das estradas no último ano?', key: 'recebeu_manutencao_das_estradas_no_ultimo_ano' as const },
              { label: 'Possui escolas?', key: 'possui_escolas' as const },
              { label: 'Possui esgotamento sanitário? *', key: 'possui_esgotamento_sanitario' as const },
              { label: 'Possui uma cultura de manejo do solo para evitar desertificação? *', key: 'possui_cultura_manejo_solo' as const },
              { label: 'É perceptível a degradação do solo? *', key: 'tem_degradacao_solo' as const },
              { label: 'É perceptível o assoreamento na rede fluvial? *', key: 'tem_assoreamento_fluvial' as const },
            ].map(({ label, key }) => {
              const v = comunidadesRuraisTradicionais[key];
              const err = v === null || v === undefined;

              return (
                <Grid item xs={12} md={6} key={key}>
                  <Typography variant="subtitle1" sx={{ mb: 0.5 }}>{label}</Typography>

                  <RadioGroup
                    row
                    name={key as string}
                    value={(() => {
                      const b = comunidadesRuraisTradicionais[key];
                      if (b === true) return 'Sim';
                      if (b === false) return 'Não';
                      return '';
                    })()}
                    onChange={(_, value) => yesNoHandler(key, value)}
                  >
                    <FormControlLabel value="Sim" control={<Radio />} label="Sim" />
                    <FormControlLabel value="Não" control={<Radio />} label="Não" />
                  </RadioGroup>

                  {err && (
                    <Typography sx={{ color: '#D32F2F', fontSize: 12 }}>
                      Selecione uma opção obrigatória.
                    </Typography>
                  )}
                </Grid>
              );

            })}
          </Grid>

          {/* Bloco 2 - Serviços adicionais (2 colunas) */}
          <Grid container spacing={3}>
            {[
              {
                label: 'Possui oferta de transporte escolar para os estudantes?',
                field: 'possui_oferta_de_transporte_escolar_para_os_estudantes',
              },
              { label: 'Possui unidade de saúde?', field: 'possui_unidade_de_saude' },
              {
                label: 'Recebe agentes de saúde do município?',
                field: 'recebeu_agentes_de_saude_do_municipio',
              },
              { label: 'Tem acesso à internet?', field: 'tem_acesso_internet' },
            ].map(({ label, field }) => {
              const map: Record<string, keyof IComunidadesRuraisTradicionais> = {
                'possui_oferta_de_transporte_escolar_para_os_estudantes':
                  'possui_oferta_de_transporte_escolar_para_os_estudantes',
                'possui_unidade_de_saude': 'possui_unidade_de_saude',
                'recebeu_agentes_de_saude_do_municipio': 'recebeu_agentes_de_saude_do_municipio',
                'tem_acesso_internet': 'tem_acesso_internet',
              };
              const key = map[field];
              const v = comunidadesRuraisTradicionais[key];
              const err = v === null || v === undefined;

              return (
                <Grid item xs={12} md={6} key={field}>
                  <Typography variant="subtitle1" sx={{ mb: 0.5 }}>
                    {label}
                  </Typography>

                  <RadioGroup
                    row
                    value={(() => {
                      if (v === true) return 'Sim';
                      if (v === false) return 'Não';
                      return '';
                    })()}
                    onChange={(_, value) => {
                      let nv: boolean | null = null;
                      if (value === 'Sim') nv = true;
                      else if (value === 'Não') nv = false;

                      console.log('[STEP2] Radio change ->', key, '=>', nv);
                      setPartialForm(key, nv);
                    }}
                  >
                    <FormControlLabel value="Sim" control={<Radio />} label="Sim" />
                    <FormControlLabel value="Não" control={<Radio />} label="Não" />
                  </RadioGroup>

                  {err && (
                    <Typography sx={{ color: '#D32F2F', fontSize: 12 }}>
                      Selecione uma opção obrigatória.
                    </Typography>
                  )}
                </Grid>
              );

            })}
          </Grid>
        </ContainerFormFormik>

        <ButtonForm
          disabled={false}
          onBack={onBack}
          onAdvanced={handleAdvanced}
          onSendApproved={handleAdvanced}
          stepAtual={stepAtual}
          totalSteps={totalSteps}
        />
      </Box>
    </>
  );
};
